export class CashManagement {
  cash: number = 1; //number can not be null when pushed to ordyx api

  public load(data: any): this {
    Object.assign(this, data);

    return this;
  }
}
